<template>
    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Stammdaten') }}</legend>
                            <select-input label="account" v-model="form.account_id" v-if="accounts">
                                <option :value="account.id" v-for="account in accounts">{{ account.name }}</option>
                            </select-input>
                            <text-input label="email" type="email" v-model="form.email" :error="form.errors.email" />
                            <text-input label="salutation" v-model="form.salutation" :error="form.errors.salutation" />
                            <text-input label="title" v-model="form.title" :error="form.errors.title" />
                            <text-input label="first_name" v-model="form.first_name" :error="form.errors.first_name" />
                            <text-input label="last_name" v-model="form.last_name" :error="form.errors.last_name" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Password') }}</legend>
                            <text-input type="password" label="password" v-model="form.password" :error="form.errors.password" autocomplete="off" />
                            <text-input type="password" label="password_confirmation" v-model="form.password_confirmation" :error="form.errors.password_confirmation" autocomplete="off" />
                        </fieldset>
                        <fieldset>
                            <legend>{{ __('Sonstiges') }}</legend>
                            <avatar :user="user" class="mb-3" v-if="user" /> 
                            <file-input :floating="true" :form="form" v-model="form.avatar" :error="form.errors.avatar" accept="image/*" label="Avatar" />
                        </fieldset>
                        <fieldset>
                            <legend>{{ __('Notes') }}</legend>
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="user">
                   {{ __('Put in trash') }}
                </button>
            </div>

        </div>

    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import FileInput from '@/shared/Inputs/FileInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    
    import Avatar from '@/shared/Avatar';

    export default {
        props: [
            'form',
            'user',
            'accounts',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            FileInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
            Avatar,
        },
        watch: {
        },
        methods: {
            destroy() {
                    this.$inertia.delete(this.route('admin.users.destroy', this.user));
            },
        },
    }
</script>
